

// // ------ version 2 --------
// import React, { forwardRef, useImperativeHandle } from 'react';
// import { usePaystackPayment } from 'react-paystack';
// import { toast } from 'sonner';
// import { Button } from 'flowbite-react';

// // Use forwardRef to expose a trigger method
// const PaymentHandler = forwardRef(
//   ({ email, amount, change, item, type, profileHandler, profile }, ref) => {
//     const onSuccess = (reference) => {
//       console.log('Paystack Success Response:', reference); // Debug response
//       if (reference.status === 'success') {
//         toast.success('Payment successful!');
//         if (item && type) {
//           // Call profileHandler with the profile and reference
//           profileHandler({ profile, reference: reference.reference });
//           change(); // Trigger state update in parent
//         }
//       } else {
//         toast.error('Payment failed. Please try again.');
//       }
//     };

//     const onClose = () => {
//       toast.info('Payment cancelled');
//     };

//     const config = {
//       reference: new Date().getTime().toString(),
//       email: email || 'default@example.com',
//       amount: Number(amount) * 100, // Ensure amount is a number
//       publicKey: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
//     };

//     const initializePayment = usePaystackPayment(config);

//     // Expose a method to trigger payment via ref
//     useImperativeHandle(ref, () => ({
//       triggerPayment: () => {
//         initializePayment(onSuccess, onClose);
//       },
//     }));

//     const handlePayment = () => {
//       if (!email || !amount) {
//         toast.error('Email and amount are required.');
//         return;
//       }
//       initializePayment(onSuccess, onClose);
//     };

//     return (
//       <div className="w-full">
//         <Button
//           className="w-full bg-blue-600 hover:bg-blue-700 text-white rounded px-4 py-2 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
//           onClick={handlePayment}
//         >
//           Pay Now
//         </Button>
//       </div>
//     );
//   }
// );

// export default PaymentHandler;




// PaymentHandler.js
import React, { useState } from "react";
import { usePaystackPayment } from "react-paystack";
import { toast } from "sonner";

const PaymentHandler = ({ jobType, setPaymentReference, onSuccess }) => {
  const [loading, setLoading] = useState(false);

  // Map jobType to amount (in kobo for Paystack)
  const amountMap = {
    Basic: 500000, // e.g., ₦5,000
    Standard: 1000000, // e.g., ₦10,000
    Premium: 2000000, // e.g., ₦20,000
  };

  const config = {
    reference: new Date().getTime().toString(), // Unique reference
    email: "user@example.com", // Replace with logged-in user's email
    amount: amountMap[jobType] || 500000, // Amount in kobo
    publicKey: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
  };

  const onSuccessPayment = (response) => {
    setPaymentReference({ reference: response.reference });
    toast.success("Payment initiated successfully");
    onSuccess(response.reference);
    setLoading(false);
  };

  const onClose = () => {
    toast.error("Payment cancelled");
    setLoading(false);
  };

  const initializePayment = usePaystackPayment(config);

  const handlePayment = () => {
    setLoading(true);
    initializePayment(onSuccessPayment, onClose);
  };

  return (
    <button
      onClick={handlePayment}
      disabled={loading || !jobType}
      className="bg-blue-500 text-white px-4 py-2 rounded"
    >
      {loading ? "Processing..." : `Pay for ${jobType}`}
    </button>
  );
};

export default PaymentHandler;